import { render, staticRenderFns } from "./language-changer.vue?vue&type=template&id=e13b3660"
import script from "./language-changer.vue?vue&type=script&lang=js"
export * from "./language-changer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports